export default "__VITE_ASSET__yH9cZ_sk__"